import React, { Component } from "react";
import PropTypes from "prop-types";

import { noop, getStrokeDasharray } from "../../utils";
import { getCurrentItem } from "../../utils/ChartDataUtil";
import { saveNodeType, isHover } from "../utils";

import HoverTextNearMouse from "../components/HoverTextNearMouse";
import {
  default as RegressionLineWithEndpoints,
  edge1Provider,
  edge2Provider,
} from "../components/RegressionLineWithEndpoints";

import ClickableCircle from "../components/ClickableCircle";

class EachRegressionLine extends Component {
  constructor(props) {
    super(props);

    this.handleEdge1Drag = this.handleEdge1Drag.bind(this);
    this.handleEdge2Drag = this.handleEdge2Drag.bind(this);

    this.handleHover = this.handleHover.bind(this);

    this.isHover = isHover.bind(this);
    this.saveNodeType = saveNodeType.bind(this);
    this.nodes = {};

    this.state = {
      hover: false,
    };
  }
  handleEdge1Drag(moreProps) {
    const { index, onDrag, snapTo } = this.props;
    const { x2Value } = this.props;

    const [x1Value] = getNewXY(moreProps, snapTo);

    onDrag(index, {
      x1Value,
      x2Value,
    });
  }
  handleEdge2Drag(moreProps) {
    const { index, onDrag, snapTo } = this.props;
    const { x1Value } = this.props;

    const [x2Value] = getNewXY(moreProps, snapTo);

    onDrag(index, {
      x1Value,
      x2Value,
    });
  }
  handleHover(moreProps) {
    if (this.state.hover !== moreProps.hovering) {
      this.setState({
        hover: moreProps.hovering,
      });
    }
  }
  render() {
    const {
      x1Value,
      x2Value,
      appearance,
      edgeInteractiveCursor,
      hoverText,
      interactive,
      selected,
      onDragComplete,
    } = this.props;

    // Extract appearance properties
    const stroke = appearance.stroke?.color || "#2196F3";
    const strokeWidth = appearance.stroke?.width || 2;
    const strokeOpacity = appearance.stroke?.opacity ?? 1;
    const strokeDash = appearance.stroke?.dash || "Solid";

    // Get theme-aware edge colors for maximum visibility
    const edgeColors = {
      stroke: "#000000", // Black stroke
      fill: "#FFFFFF", // White fill
    };
    const actualEdgeFill = edgeColors.fill;
    // Force larger radius for better visibility
    const circleRadius = 6;

    const { hover } = this.state;

    const hoverHandler = interactive
      ? { onHover: this.handleHover, onUnHover: this.handleHover }
      : {};

    const {
      enable: hoverTextEnabled,
      selectedText: hoverTextSelected,
      text: hoverTextUnselected,
      ...restHoverTextProps
    } = hoverText;

    return (
      <g>
        <RegressionLineWithEndpoints
          ref={this.saveNodeType("line")}
          selected={selected || hover}
          {...hoverHandler}
          x1Value={x1Value}
          x2Value={x2Value}
          stroke={stroke}
          strokeWidth={hover || selected ? strokeWidth + 1 : strokeWidth}
          strokeDasharray={getStrokeDasharray(strokeDash)}
          strokeOpacity={strokeOpacity}
        />
        <ClickableCircle
          ref={this.saveNodeType("edge1")}
          show={selected || hover}
          xyProvider={edge1Provider(this.props)}
          r={circleRadius}
          fill={actualEdgeFill}
          stroke={edgeColors.stroke}
          strokeWidth={2}
          strokeOpacity={1}
          interactiveCursorClass={edgeInteractiveCursor}
          onDrag={this.handleEdge1Drag}
          onDragComplete={onDragComplete}
        />
        <ClickableCircle
          ref={this.saveNodeType("edge2")}
          show={selected || hover}
          xyProvider={edge2Provider(this.props)}
          r={circleRadius}
          fill={actualEdgeFill}
          stroke={edgeColors.stroke}
          strokeWidth={2}
          strokeOpacity={1}
          interactiveCursorClass={edgeInteractiveCursor}
          onDrag={this.handleEdge2Drag}
          onDragComplete={onDragComplete}
        />
        <HoverTextNearMouse
          show={hoverTextEnabled && hover && interactive}
          {...restHoverTextProps}
          text={selected ? hoverTextSelected : hoverTextUnselected}
        />
      </g>
    );
  }
}

export function getNewXY(moreProps, snapTo) {
  const { xScale, mouseXY, plotData, xAccessor } = moreProps;

  const currentItem = getCurrentItem(xScale, xAccessor, mouseXY, plotData);
  const x = xAccessor(currentItem);
  return [x];
}

EachRegressionLine.propTypes = {
  x1Value: PropTypes.any.isRequired,
  x2Value: PropTypes.any.isRequired,

  index: PropTypes.number,
  interactive: PropTypes.bool,

  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      color: PropTypes.string,
      width: PropTypes.number,
      opacity: PropTypes.number,
      dash: PropTypes.string,
    }),
  }).isRequired,

  edgeInteractiveCursor: PropTypes.string,
  hoverText: PropTypes.object.isRequired,

  onDrag: PropTypes.func,
  onDragComplete: PropTypes.func,
  snapTo: PropTypes.func,

  selected: PropTypes.bool.isRequired,
};

EachRegressionLine.defaultProps = {
  onDrag: noop,
  onDragComplete: noop,

  interactive: true,
  edgeInteractiveCursor: "react-stockcharts-move-cursor",
  hoverText: {
    enable: false,
  },
  selected: false,
};

export default EachRegressionLine;
